import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@garnet/ui/styles/garnet.css';
import { App } from './App.js';

const root = document.getElementById('root');
if (!root) throw new Error('missing #root');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/**
 * Offline-first service-worker registration (PRD §10.4). The worker pre-caches the shell so
 * the inspector app launches and runs without a connection; capture writes buffer locally
 * and sync on reconnect. Registration is a no-op where the API is unavailable (e.g. tests).
 */
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      /* registration is best-effort; the app still runs from the network */
    });
  });
}
